import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { MaskedLines } from "@/components/Reveal";

export const AccentButton = ({ to, href, children, testid, ...rest }) => {
  const cls = "on-dark inline-flex items-center justify-center gap-2 text-sm font-semibold text-white px-7 py-4 transition-transform hover:-translate-y-0.5";
  const style = { background: "var(--accent)" };
  const inner = <>{children} <ArrowRight size={16} /></>;
  if (to) return <Link to={to} data-testid={testid} className={cls} style={style} {...rest}>{inner}</Link>;
  return <a href={href} data-testid={testid} className={cls} style={style} {...rest}>{inner}</a>;
};

export const OutlineButton = ({ to, href, children, testid, ...rest }) => {
  const cls = "inline-flex items-center justify-center gap-2 text-sm font-semibold text-white px-7 py-4 border border-white/25 hover:border-white transition-colors";
  if (to) return <Link to={to} data-testid={testid} className={cls} {...rest}>{children}</Link>;
  return <a href={href} data-testid={testid} className={cls} {...rest}>{children}</a>;
};

export const Overline = ({ children }) => (
  <span className="inline-block text-xs sm:text-sm tracking-[0.25em] uppercase font-bold" style={{ color: "var(--accent)" }}>
    {children}
  </span>
);

// Interior page hero (image bg + dark overlay + masked title).
export const PageHero = ({ image, imagePosition = "center", alt = "", overline, titleLines, subtitle }) => (
  <section className="on-dark relative min-h-[62vh] md:min-h-[70vh] flex items-end overflow-hidden">
    <div className="absolute inset-0">
      <img src={image} alt={alt} loading="eager" className="w-full h-full object-cover" style={{ objectPosition: imagePosition }} />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0C] via-[#0A0A0C]/60 to-black/50" />
    </div>
    <div className="relative z-10 mx-auto max-w-[1400px] w-full px-5 md:px-8 pb-14 md:pb-20">
      {overline && <div className="mb-4"><Overline>{overline}</Overline></div>}
      <h1 className="font-display font-semibold text-white text-4xl sm:text-6xl md:text-7xl leading-[1.05]">
        <MaskedLines lines={titleLines} />
      </h1>
      {subtitle && <p className="mt-6 max-w-2xl text-base sm:text-lg text-zinc-300 leading-relaxed">{subtitle}</p>}
    </div>
  </section>
);
